module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAA5CAYAAADzyZF0AAAAHUlEQVQokWM8eeLhfwYoYGJAAqOcUc5w4DAwMAAAlZUD4+plHNgAAAAASUVORK5CYII="